export enum INavigateKey {
  Home = 'home',
  Campaigns = 'campaigns',
  CampaignDetails = 'campaign-details',
  CampaignAnalytic = 'campaign-analytic',
  CampaignGroupDetails = 'campaign-group-details',
  CampaignGroupAnalytic = 'campaign-group-analytic',
  CampaignNew = 'campaign-new',
  CampaignTemplate = 'campaign',
  CampaignMultipage = 'campaign-multipage',
  CampaignPrice = 'campaign-price',
  CampaignUrlRedirect = 'campaign-url-redirect',
  Analytics = 'analytics',
  AnalyticsDetail = 'analytics-detail',
  Reports = 'reports',
  OrderListing = 'order-listing',
  Plan = 'plan',
  Preferences = 'preferences',
  OnboardingSurvey = 'onboarding',
  OnboardingTemplate = 'template',
  OnboardingPricing = 'pricing',
  OnboardingMultiPage = 'multipage',
  ThankYou = 'thank-you',
  DevMode = 'dev-mode',
  Heatmap = 'heatmap',
}
